import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import PdpSharedBlurbPcs from '../PdpSharedBlurbs/PdpSharedBlurbPcs';
import PdpSharedBlurbLeadTime from '../PdpSharedBlurbs/PdpSharedBlurbLeadTime';
import PdpSharedBlurbShipping from '../PdpSharedBlurbs/PdpSharedBlurbShipping';
import PdpSharedProtectionOrLoyalty from '../PdpSharedBlurbs/PdpSharedProtectionOrLoyalty';
import PdpSharedBlurbReturns from '../PdpSharedBlurbs/PdpSharedBlurbReturns';

// styles
import styles from './PdpRespSidebarBlurbs.scss';

// helpers
import get from 'lodash.get';

export function PdpRespSidebarBlurbs(props) {
    const {
        currency,
        relayVariables,
        viewer,
        item,
        user,
        displayInfo,
        vipUserRelationship,
        localDeliveryOptions,
        domesticDeliveryOptions,
    } = props;
    const pricingDisplayInfo = get(displayInfo, 'pricing') || null;
    const renderBlurbs =
        !!pricingDisplayInfo && !pricingDisplayInfo.showSold && !pricingDisplayInfo.showUnavailable;

    if (!renderBlurbs) {
        return null;
    }

    return (
        <div className={styles.container}>
            <PdpSharedBlurbPcs user={user} vipUserRelationship={vipUserRelationship} />
            <PdpSharedBlurbLeadTime item={item} />
            <PdpSharedBlurbShipping
                currency={currency}
                itemId={relayVariables.itemId}
                userId={relayVariables.userId}
                viewer={viewer}
                user={user}
                item={item}
                localDeliveryOptions={localDeliveryOptions}
                domesticDeliveryOptions={domesticDeliveryOptions}
            />
            <PdpSharedProtectionOrLoyalty item={item} user={user} viewer={viewer} />
            <PdpSharedBlurbReturns
                item={item}
                itemId={relayVariables.itemId}
                user={user}
                userId={relayVariables.userId}
            />
        </div>
    );
}

PdpRespSidebarBlurbs.propTypes = {
    currency: PropTypes.string,
    relayVariables: PropTypes.shape({
        userId: PropTypes.string,
        itemId: PropTypes.string.isRequired,
    }).isRequired,
    viewer: PropTypes.object,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
    displayInfo: PropTypes.object,
    vipUserRelationship: PropTypes.object,
    localDeliveryOptions: PropTypes.object,
    domesticDeliveryOptions: PropTypes.object,
};

export default createFragmentContainer(PdpRespSidebarBlurbs, {
    viewer: graphql`
        fragment PdpRespSidebarBlurbs_viewer on Viewer {
            ...PdpSharedBlurbShipping_viewer
        }
    `,
    item: graphql`
        fragment PdpRespSidebarBlurbs_item on Item {
            ...PdpSharedBlurbLeadTime_item
            ...PdpSharedBlurbShipping_item
            ...PdpSharedProtectionOrLoyalty_item
            ...PdpSharedBlurbReturns_item
        }
    `,
    user: graphql`
        fragment PdpRespSidebarBlurbs_user on User {
            ...PdpSharedBlurbPcs_user
            ...PdpSharedBlurbShipping_user
            ...PdpSharedProtectionOrLoyalty_user
            ...PdpSharedBlurbReturns_user
        }
    `,
    displayInfo: graphql`
        fragment PdpRespSidebarBlurbs_displayInfo on ItemDisplayInfo {
            pricing {
                showSold
                showUnavailable
            }
        }
    `,
    vipUserRelationship: graphql`
        fragment PdpRespSidebarBlurbs_vipUserRelationship on UserRelationship {
            ...PdpSharedBlurbPcs_vipUserRelationship
        }
    `,
    localDeliveryOptions: graphql`
        fragment PdpRespSidebarBlurbs_localDeliveryOptions on ShipmentQuoteConnection {
            ...PdpSharedBlurbShipping_localDeliveryOptions
        }
    `,
    domesticDeliveryOptions: graphql`
        fragment PdpRespSidebarBlurbs_domesticDeliveryOptions on ShipmentQuoteConnection {
            ...PdpSharedBlurbShipping_domesticDeliveryOptions
        }
    `,
});
